export default __webpack_public_path__ + "static/media/Alex_Ting_Picture_Crop.2c537707.jpg";